import {ModuleWithProviders, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {HomeComponent} from './home.component';
import {HomeAuthResolver} from './home-auth-resolver.service';
import {SharedModule} from '../shared';
import {HomeRoutingModule} from './home-routing.module';
// const homeRouting: ModuleWithProviders = RouterModule.forChild([
//     {
//         path: '',
//         component: HomeComponent,
//         resolve: {
//             isAuthenticated: HomeAuthResolver
//         }
//     }
// ]);

@NgModule({
    imports: [
        HomeRoutingModule,
        SharedModule
    ],
    declarations: [
        HomeComponent
    ],
    providers: [
        HomeAuthResolver
    ]
})
export class HomeModule {
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/home/home.module.ts